import Bundle from './Bundle';

export default Bundle;
